import './polyfills';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { setupChunkErrorHandler } from '@/utils/chunkErrorHandler';

console.log('🚀 Main.tsx loading...');

// Setup global chunk error handling
setupChunkErrorHandler();

// Add safety diagnostic for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('🚨 Unhandled promise rejection:', event.reason);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
